import { useTranslation } from "next-i18next";
import Image from "next/image";
import CorporateEmailTable from "./CorporateEmailTable";

const ProfessionalAlternativeMakdosMailHosting = () => {
    const { t } = useTranslation(["common", "homepage", "email"]);

    const data = [
        {
            properties: t("email:customDomainNameUsage"),
            yandexmail: t("email:yes"),
            gmail: t("email:yes"),
            makdos: t("email:yes"),
        },
        {
            properties: t("email:dailyBackup"),
            yandexmail: t("email:no"),
            gmail: t("email:no"),
            makdos: t("email:yes"),
        },
        {
            properties: t("email:spamProtection"),
            yandexmail: t("email:middle"),
            gmail: t("email:middle"),
            makdos: t("email:developed"),
        },
        {
            properties: t("email:price"),
            yandexmail: t("email:high"),
            gmail: t("email:high"),
            makdos: t("email:suitable"),
        },
    ];

    return (
        <div className="container mx-auto my-6 lg:my-12">
            <div>
                <h2 className="relative px-2 text-3xl font-bold text-titleColor lg:px-0 lg:text-center lg:text-4xl text-after-shadow-email">{t("email:professionalAlternativeToGmailAndYandexMail")}</h2>
                <h2 className="relative px-2 text-3xl font-bold lg:text-center text-titleColor lg:px-0 lg:text-4xl text-after-shadow-email2">{t("email:makdosMailHosting")}</h2>
                <div className="px-2 py-8 text-sm text-textGray lg:text-xl lg:px-0" dangerouslySetInnerHTML={{ __html: t("email:professionalAlternativeToGmailAndYandexMailDesc") }}></div>
            </div>

            <div className="flex flex-col items-center space-x-3 space-y-5 lg:pt-6 lg:space-y-0 lg:flex-row">
                <Image src={"/ProfessionalAlternativeMakdosMailHosting.svg"} width={232} height={261} alt={t("email:makdosMailHosting")} title={t("email:makdosMailHosting")} />
                <div className="w-full overflow-x-auto">
                    <CorporateEmailTable data={data} />
                </div>
            </div>
        </div>
    )
}

export default ProfessionalAlternativeMakdosMailHosting